import type {ChronologicalCommentsSort} from '@github-ui/commenting/useCommentsSortPreference'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {clsx} from 'clsx'

import {TEST_IDS} from '../../constants/test-ids'
import styles from './CommentsHeader.module.css'
import {CommentsSortMenu} from './CommentsSortMenu'

type CommentsHeaderProps = {
  headingId: string
  sort: ChronologicalCommentsSort
  onSortChange: (sort: ChronologicalCommentsSort) => void
}

export function CommentsHeader({headingId, sort, onSortChange}: CommentsHeaderProps) {
  return (
    <div
      data-testid={TEST_IDS.commentsHeader}
      className={clsx(styles.container, !isFeatureEnabled('issue_inline_avatars') && styles.container_gutter)}
    >
      <h2 id={headingId} className={styles.heading}>
        Comments
      </h2>
      <div className={styles.controls}>
        <CommentsSortMenu sort={sort} onSortChange={onSortChange} />
      </div>
    </div>
  )
}
